// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__PK8HK","listItem":"List_listItem___DW0U","icon":"List_icon__Iqf0H"};